export function appendUrlParams(
  url: string,
  params: Record<string, string>
): string {
  const _url = createURLWithDefaultProtocol(url);

  for (const param in params) {
    _url.searchParams.append(param, params[param]);
  }

  return _url.toString();
}

function createURLWithDefaultProtocol(
  siteString: string,
  defaultProtocol: string = 'https'
): URL {
  if (!/^(https?):\/\//i.test(siteString)) {
    siteString = `${defaultProtocol}://${siteString}`;
  }

  const url = new URL(siteString);

  return url;
}
